import React from "react";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Estimator from "@/components/Estimator";
import Marquee from "@/components/Marquee";
import Services from "@/components/Services";
import Manifesto from "@/components/Manifesto";
import SpecialOffers from "@/components/SpecialOffers";
import Coverage from "@/components/Coverage";
import Testimonials from "@/components/Testimonials";
import FAQ from "@/components/FAQ";
import QuoteForm from "@/components/QuoteForm";
import Footer from "@/components/Footer";
import SmoothScroll from "@/components/SmoothScroll";

export default function Home() {
  return (
    <main className="bg-[var(--jb-bone)]" data-testid="home-page">
      <SmoothScroll />
      <Header />
      <Hero />
      <Estimator />
      <Marquee />
      <Services />
      <Manifesto />
      <SpecialOffers />
      <Coverage />
      <Testimonials />
      <FAQ />
      <QuoteForm />
      <Footer />
    </main>
  );
}
